var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c("info-dialog", {
        attrs: { "invoicing-company": _vm.invoicingCompany },
        model: {
          value: _vm.showInfoDialog,
          callback: function($$v) {
            _vm.showInfoDialog = $$v
          },
          expression: "showInfoDialog"
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "full-width": !_vm.$vuetify.breakpoint.smAndDown,
            "max-width": "500"
          },
          model: {
            value: _vm.showBillableDialog,
            callback: function($$v) {
              _vm.showBillableDialog = $$v
            },
            expression: "showBillableDialog"
          }
        },
        [
          _c("v-card", { staticClass: "pa-4" }, [
            _c("div", { staticClass: "text--primary" }, [
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "Export a " +
                      _vm._s(_vm.$t("terms.billable-expense")) +
                      " from a " +
                      _vm._s(_vm.$t("terms.vendor"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Assign the " +
                      _vm._s(_vm.$t("terms.billable-expense")) +
                      " to a customer"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("Provide the expense account line item for the bill")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Optionally add income items such as equipment usage or dispatch deductions"
                  )
                ]),
                _vm._v(" "),
                _vm.isUsingTax
                  ? _c("li", [_vm._v("Specify Tax Liability / Withholding")])
                  : _vm._e()
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "full-width": !_vm.$vuetify.breakpoint.smAndDown,
            "max-width": "500"
          },
          model: {
            value: _vm.showTransactionHistory,
            callback: function($$v) {
              _vm.showTransactionHistory = $$v
            },
            expression: "showTransactionHistory"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c("v-load-transaction-histories", {
                attrs: {
                  company: _vm.invoicingCompany,
                  transaction: _vm.transaction
                }
              }),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showTransactionHistory = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "full-width": !_vm.$vuetify.breakpoint.smAndDown,
            "max-width": "500"
          },
          model: {
            value: _vm.showCustomerDialog,
            callback: function($$v) {
              _vm.showCustomerDialog = $$v
            },
            expression: "showCustomerDialog"
          }
        },
        [
          _c("v-card", { staticClass: "pa-4" }, [
            _c("div", { staticClass: "text--primary" }, [
              _c("ul", [
                _c("li", [
                  _vm._v("Create an invoice against the customer/dispatcher")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("Provide the income account line item")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Optionally add internal expenses such as dispatch or load withholding"
                  )
                ]),
                _vm._v(" "),
                _vm.isUsingTax
                  ? _c("li", [_vm._v("Specify Tax Liability / Withholding")])
                  : _vm._e()
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", lazy: "", "max-width": "700" },
          on: {
            input: function(v) {
              return v
            }
          },
          model: {
            value: _vm.showInvoiceDialog,
            callback: function($$v) {
              _vm.showInvoiceDialog = $$v
            },
            expression: "showInvoiceDialog"
          }
        },
        [
          _c(
            "v-card",
            { class: { "pa-4": !_vm.$vuetify.breakpoint.smAndDown } },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-toolbar",
                        [
                          _c("img", {
                            staticClass: "align-center cursor-pointer",
                            attrs: {
                              height: "38",
                              width: "38",
                              src: "/static/Quickbooks-Logo.png"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-toolbar-title", [
                            _vm._v(_vm._s(_vm.quickbooksExportTitle))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-tile",
                            { staticClass: "pl-2" },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "Invoiced to: " +
                                        _vm._s(_vm.txnCustomerCompanyName)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      "Paid to: " +
                                        _vm._s(_vm.txnVendorCompanyName)
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.billOfLadingNumber
                            ? _c(
                                "v-list-tile",
                                { staticClass: "pl-2" },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("terms.bill-of-lading")
                                            ) +
                                            " Number: " +
                                            _vm._s(_vm.billOfLadingNumber) +
                                            "\n                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-sub-title",
                                        [
                                          _vm._.get(
                                            _vm.transaction,
                                            "load.billOfLading.link",
                                            false
                                          )
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "primary--text ma-0 px-0",
                                                  attrs: { flat: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openBillOfLading()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "primary"
                                                      }
                                                    },
                                                    [_vm._v("attachment")]
                                                  ),
                                                  _vm._v(
                                                    "\n                    View " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "terms.bill-of-lading"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.exportQuickbooksStep
                            ? _c(
                                "v-list-tile",
                                { staticClass: "pl-2" },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-list-tile-sub-title",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "primary--text ma-0 px-0",
                                              attrs: { flat: "" },
                                              on: {
                                                click: function($event) {
                                                  _vm.showTransactionHistory = true
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [_vm._v("timeline")]
                                              ),
                                              _vm._v(
                                                "\n                    History\n                  "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isQuickbooksConnected(_vm.invoicingCompany)
                    ? _c(
                        "v-alert",
                        {
                          attrs: {
                            type: "warning",
                            value:
                              _vm.daysUntilQuickbooksCredentialsExpire(
                                _vm.invoicingCompany
                              ) < 8
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _vm.isQuickbooksConnected(_vm.invoicingCompany)
                                ? _c("v-flex", { attrs: { xs8: "" } }, [
                                    _c("span", [
                                      _vm._v(
                                        "Your Quickbooks Credentials expire in " +
                                          _vm._s(
                                            _vm.daysUntilQuickbooksCredentialsExpire(
                                              _vm.invoicingCompany
                                            )
                                          ) +
                                          " days."
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "accent",
                                        to:
                                          "/companies/" +
                                          _vm.invoicingCompany.id +
                                          "/profile#quickbooks"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Fix It\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer", { staticClass: "mb-3" }),
                  _vm._v(" "),
                  _vm.exportQuickbooksStep == null
                    ? _c(
                        "v-card",
                        { attrs: { "pa-0": "", flat: "" } },
                        [
                          _c(
                            "v-container",
                            {
                              staticClass: "px-0 pt-1",
                              attrs: { fluid: "", "grid-list-lg": "" }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass:
                                            "text--primary text--darken-2"
                                        },
                                        [
                                          _c(
                                            "v-toolbar",
                                            {
                                              staticClass: "text--white",
                                              attrs: {
                                                color: "primary ",
                                                flat: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-toolbar-title",
                                                { staticClass: "white--text" },
                                                [
                                                  _vm._v(
                                                    "\n                      Billable Expense\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-sub-title",
                                                [
                                                  _vm._v(
                                                    "\n                      for dispatched loads\n                      "
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        fab: "",
                                                        small: "",
                                                        flat: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.showBillableDialog = true
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("help_outline")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-actions",
                                            { staticClass: "align-center" },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    block: "",
                                                    color: "accent",
                                                    large: ""
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.setupBillableExpenseFlow
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "pr-2",
                                                      attrs: { large: "" }
                                                    },
                                                    [_vm._v("receipt")]
                                                  ),
                                                  _vm._v(
                                                    "\n                      Export " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "terms.billable-expense"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c(
                                        "v-card",
                                        [
                                          _c(
                                            "v-toolbar",
                                            { attrs: { flat: "" } },
                                            [
                                              _c("v-toolbar-title", [
                                                _vm._v(
                                                  "\n                      Customer Invoice\n                    "
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-sub-title",
                                                [
                                                  _vm._v(
                                                    "\n                      for direct invoicing\n                      "
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        fab: "",
                                                        small: "",
                                                        flat: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.showCustomerDialog = true
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("help_outline")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-actions",
                                            { staticClass: "align-center" },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    block: "",
                                                    large: "",
                                                    color: "primary darken-1"
                                                  },
                                                  on: {
                                                    click: _vm.setupInvoiceFlow
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "pr-2",
                                                      attrs: {
                                                        large: "",
                                                        color: "white"
                                                      }
                                                    },
                                                    [_vm._v("monetization_on")]
                                                  ),
                                                  _vm._v(
                                                    "\n                      Create Invoice\n                    "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            { staticClass: "align-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "accent",
                                    flat: "",
                                    large: "",
                                    outline: ""
                                  },
                                  on: { click: _vm.resetState }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "pr-2",
                                      attrs: { large: "" }
                                    },
                                    [_vm._v("cancel")]
                                  ),
                                  _vm._v("\n              Cancel\n            ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "v-stepper",
                            {
                              model: {
                                value: _vm.exportQuickbooksStep,
                                callback: function($$v) {
                                  _vm.exportQuickbooksStep = $$v
                                },
                                expression: "exportQuickbooksStep"
                              }
                            },
                            [
                              _c(
                                "v-stepper-header",
                                [
                                  _c(
                                    "v-stepper-step",
                                    {
                                      attrs: {
                                        step: "1",
                                        complete: _vm.exportQuickbooksStep > 1
                                      }
                                    },
                                    [_vm._v("Load")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-stepper-step",
                                    {
                                      attrs: {
                                        step: "2",
                                        complete: _vm.exportQuickbooksStep > 2
                                      }
                                    },
                                    [
                                      _vm.createInvoice
                                        ? _c("span", [_vm._v("Service")])
                                        : _c("span", [_vm._v("Expense")])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.createInvoice
                                    ? _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            step:
                                              _vm.exportQuickbooksDiscountsStep,
                                            complete:
                                              _vm.exportQuickbooksStep >
                                              _vm.exportQuickbooksDiscountsStep
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Discounts\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-stepper-step",
                                    {
                                      attrs: {
                                        step: _vm.exportQuickbooksTaxStep,
                                        complete:
                                          _vm.exportQuickbooksStep >
                                          _vm.exportQuickbooksTaxStep
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Tax\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-stepper-items",
                                [
                                  _c(
                                    "v-stepper-content",
                                    { attrs: { step: "1" } },
                                    [
                                      _c("h3", [_vm._v("Load's Customer")]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-light" },
                                        [
                                          _vm._v(
                                            "\n                Select " +
                                              _vm._s(_vm.$t("site-title")) +
                                              " customer from your Quickbooks customers\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        { attrs: { "two-line": "" } },
                                        [
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c("v-autocomplete", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  items: _vm.customers,
                                                  loading: _vm.loadingCustomers,
                                                  label: "Quickbooks Customer",
                                                  "item-text": "selectDisplay",
                                                  "item-value": "qbCompanyId",
                                                  "return-object": "",
                                                  disabled:
                                                    _vm.loadingCustomers,
                                                  "error-messages": _vm.errors.first(
                                                    "customer",
                                                    "step1"
                                                  ),
                                                  "data-vv-as":
                                                    "Quickbooks Customer",
                                                  "data-vv-name": "customer",
                                                  "data-vv-scope": "step1"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "item",
                                                    fn: function(slotItems) {
                                                      return [
                                                        _c(
                                                          "v-layout",
                                                          {
                                                            attrs: {
                                                              column: ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "title mr-3 mt-1 primary--text"
                                                              },
                                                              [
                                                                _vm.customerCompanyName(
                                                                  slotItems.item
                                                                )
                                                                  ? _c(
                                                                      "span",
                                                                      [
                                                                        slotItems
                                                                          .item
                                                                          .qbCompanyId
                                                                          ? _c(
                                                                              "v-icon",
                                                                              {
                                                                                attrs: {
                                                                                  color:
                                                                                    "primary"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "business"
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "v-icon",
                                                                              {
                                                                                attrs: {
                                                                                  color:
                                                                                    "transparent"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "add_circle"
                                                                                )
                                                                              ]
                                                                            ),
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              _vm.customerCompanyName(
                                                                                slotItems.item
                                                                              )
                                                                            ) +
                                                                            "\n                          "
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _c(
                                                                      "span",
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "primary"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "person_outline"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              _vm.customerDisplayName(
                                                                                slotItems.item
                                                                              )
                                                                            ) +
                                                                            "\n                          "
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm.customerCompanyName(
                                                              slotItems.item
                                                            ) &&
                                                            _vm.customerContactName(
                                                              slotItems.item
                                                            )
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "grey--text caption"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "primary"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "person_outline"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.customerContactName(
                                                                            slotItems.item
                                                                          )
                                                                        )
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _vm.customerCompanyName(
                                                                      slotItems.item
                                                                    ) !==
                                                                    _vm.customerDisplayName(
                                                                      slotItems.item
                                                                    )
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "font-italic font-weight-light"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                          " +
                                                                                _vm._s(
                                                                                  _vm.customerDisplayName(
                                                                                    slotItems.item
                                                                                  )
                                                                                ) +
                                                                                "\n                        "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ]),
                                                model: {
                                                  value: _vm.qbCustomer,
                                                  callback: function($$v) {
                                                    _vm.qbCustomer = $$v
                                                  },
                                                  expression: "qbCustomer"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-avatar",
                                                { staticClass: "pl-3" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        fab: "",
                                                        small: "",
                                                        flat: "",
                                                        color: "accent",
                                                        disabled:
                                                          _vm.loadingCustomers
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "accent"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.refreshQuickbooksCustomers(
                                                                _vm
                                                                  .invoicingCompany
                                                                  .id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("refresh")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("h3", [
                                        _vm._v("Full Invoiced Amount")
                                      ]),
                                      _vm._v(" "),
                                      _c("v-float-field", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        staticClass: "pl-3",
                                        attrs: {
                                          label: "Invoiced Amount ($)",
                                          "error-messages": _vm.errors.first(
                                            "amount",
                                            "step1"
                                          ),
                                          "data-vv-as": "Invoiced Amount",
                                          "data-vv-name": "amount",
                                          "data-vv-scope": "step1"
                                        },
                                        model: {
                                          value: _vm.invoicedAmount,
                                          callback: function($$v) {
                                            _vm.invoicedAmount = $$v
                                          },
                                          expression: "invoicedAmount"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("h3", [
                                        _vm._v("Assign Document Number")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-radio-group",
                                        {
                                          attrs: { mandatory: "" },
                                          model: {
                                            value: _vm.selectedInvoiceNumber,
                                            callback: function($$v) {
                                              _vm.selectedInvoiceNumber = $$v
                                            },
                                            expression: "selectedInvoiceNumber"
                                          }
                                        },
                                        [
                                          _vm._l(_vm.invoiceOptions, function(
                                            option,
                                            index
                                          ) {
                                            return _c("v-radio", {
                                              key: "invoiceOp_" + index,
                                              attrs: {
                                                label: option.label,
                                                value: option.value
                                              }
                                            })
                                          }),
                                          _vm._v(" "),
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Custom",
                                              value: "__other"
                                            }
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.selectedInvoiceNumber === "__other"
                                        ? _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              label: "Custom Document Number",
                                              "error-messages": _vm.errors.first(
                                                "documentNumber",
                                                "step1"
                                              ),
                                              "data-vv-as": "Document Number",
                                              "data-vv-name": "documentNumber",
                                              "data-vv-scope": "step1"
                                            },
                                            model: {
                                              value: _vm.customInvoiceNumber,
                                              callback: function($$v) {
                                                _vm.customInvoiceNumber = $$v
                                              },
                                              expression: "customInvoiceNumber"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            block: "",
                                            large: "",
                                            disabled: _vm.errors.any("step1"),
                                            color: _vm.btnColor
                                          },
                                          on: {
                                            click:
                                              _vm.setupExportQuickbooksStep2
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "pr-2",
                                              attrs: {
                                                large: "",
                                                color: "white"
                                              }
                                            },
                                            [
                                              _vm.createInvoice
                                                ? [
                                                    _vm._v(
                                                      "\n                      account_balance\n                    "
                                                    )
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                      credit_card\n                    "
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _vm.createInvoice
                                            ? _c("span", [
                                                _vm._v(
                                                  "Select Product or Service"
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v("Select Expense Account")
                                              ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            block: "",
                                            flat: "",
                                            color: _vm.btnColor
                                          },
                                          on: { click: _vm.openQuickbooksModal }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Start Over\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-stepper-content",
                                    { attrs: { step: "2" } },
                                    [
                                      _c(
                                        "v-list",
                                        [
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _vm.createInvoice
                                                    ? _c(
                                                        "v-list-tile-title",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Product or Service"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.createInvoice
                                                    ? _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _vm._v(
                                                            "invoice sales line item"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !_vm.createInvoice
                                                    ? _c(
                                                        "v-list-tile-title",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Expense Account"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !_vm.createInvoice
                                                    ? _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _vm._v(
                                                            "account based expense line"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.createInvoice
                                            ? _c(
                                                "v-list-tile",
                                                { staticClass: "pt-1" },
                                                [
                                                  _c("v-autocomplete", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass: "mt-2",
                                                    attrs: {
                                                      items: _vm.salesItems,
                                                      loading:
                                                        _vm.loadingSalesItems,
                                                      disabled:
                                                        _vm.loadingSalesItems,
                                                      label:
                                                        "Quickbooks Sales Item",
                                                      "item-text":
                                                        "description",
                                                      "item-value": "itemId",
                                                      "return-object": "",
                                                      "error-messages": _vm.errors.first(
                                                        "salesItem",
                                                        "step2"
                                                      ),
                                                      "data-vv-as":
                                                        "Quickbooks Sales Item",
                                                      "data-vv-name":
                                                        "salesItem",
                                                      "data-vv-scope": "step2"
                                                    },
                                                    model: {
                                                      value: _vm.qbSalesItem,
                                                      callback: function($$v) {
                                                        _vm.qbSalesItem = $$v
                                                      },
                                                      expression: "qbSalesItem"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-avatar",
                                                    { staticClass: "pl-3" },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            fab: "",
                                                            small: "",
                                                            flat: "",
                                                            color: "accent",
                                                            disabled:
                                                              _vm.loadingSalesItems
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color: "accent"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.refreshQuickbooksSalesItems(
                                                                    _vm
                                                                      .invoicingCompany
                                                                      .id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("refresh")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.createInvoice
                                            ? _c(
                                                "v-list-tile",
                                                { staticClass: "pt-1 pb-3" },
                                                [
                                                  _c("v-autocomplete", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass: "mt-2",
                                                    attrs: {
                                                      items:
                                                        _vm.quickbooksExpenseAccounts,
                                                      loading:
                                                        _vm.loadingAccounts,
                                                      disabled:
                                                        _vm.loadingAccounts,
                                                      label:
                                                        "Quickbooks Account",
                                                      "item-text":
                                                        "accountName",
                                                      "item-value": "accountId",
                                                      "auto-select-first": "",
                                                      "return-object": "",
                                                      "error-messages": _vm.errors.first(
                                                        "account",
                                                        "step2"
                                                      ),
                                                      "data-vv-as":
                                                        "Quickbooks Account",
                                                      "data-vv-name": "account",
                                                      "data-vv-scope": "step2"
                                                    },
                                                    model: {
                                                      value: _vm.exportAccount,
                                                      callback: function($$v) {
                                                        _vm.exportAccount = $$v
                                                      },
                                                      expression:
                                                        "exportAccount"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-avatar",
                                                    { staticClass: "pl-3" },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            fab: "",
                                                            small: "",
                                                            flat: "",
                                                            color: "accent"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color: "accent"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.refreshQuickbooksAccounts(
                                                                    _vm
                                                                      .invoicingCompany
                                                                      .id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("refresh")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("v-divider"),
                                          _vm._v(" "),
                                          !_vm.createInvoice
                                            ? _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c(
                                                        "v-list-tile-title",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.vendorName
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "site-title"
                                                              )
                                                            ) +
                                                              " Team Driver or Outside Trucking Company"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.createInvoice
                                            ? _c(
                                                "v-list-tile",
                                                { staticClass: "pt-1 pb-3" },
                                                [
                                                  _c("v-autocomplete", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass: "mt-2",
                                                    attrs: {
                                                      items: _vm.vendors,
                                                      loading:
                                                        _vm.loadingVendors,
                                                      disabled:
                                                        _vm.loadingVendors,
                                                      label:
                                                        "Quickbooks Vendor",
                                                      "item-text":
                                                        "selectDisplay",
                                                      "item-value":
                                                        "qbCompanyId",
                                                      "error-messages": _vm.errors.first(
                                                        "vendor",
                                                        "step2"
                                                      ),
                                                      "data-vv-as":
                                                        "Quickbooks Vendor",
                                                      "data-vv-name": "vendor",
                                                      "data-vv-scope": "step2",
                                                      "return-object": ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "item",
                                                          fn: function(
                                                            slotItems
                                                          ) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "title mr-3 mt-1 primary--text"
                                                                },
                                                                [
                                                                  _vm.customerCompanyName(
                                                                    slotItems.item
                                                                  )
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs: {
                                                                                color:
                                                                                  "primary"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "business"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                          " +
                                                                              _vm._s(
                                                                                _vm.customerCompanyName(
                                                                                  slotItems.item
                                                                                )
                                                                              ) +
                                                                              "\n                          "
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs: {
                                                                                color:
                                                                                  "primary"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "person_outline"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                            " +
                                                                              _vm._s(
                                                                                _vm.customerDisplayName(
                                                                                  slotItems.item
                                                                                )
                                                                              ) +
                                                                              "\n                          "
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.customerCompanyName(
                                                                slotItems.item
                                                              ) &&
                                                              _vm.customerContactName(
                                                                slotItems.item
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "grey--text caption"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "person_outline"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.customerContactName(
                                                                                slotItems.item
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm.customerCompanyName(
                                                                        slotItems.item
                                                                      ) !==
                                                                      _vm.customerDisplayName(
                                                                        slotItems.item
                                                                      )
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "font-italic font-weight-light"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            " +
                                                                                  _vm._s(
                                                                                    _vm.customerDisplayName(
                                                                                      slotItems.item
                                                                                    )
                                                                                  ) +
                                                                                  "\n                          "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      2847129195
                                                    ),
                                                    model: {
                                                      value: _vm.qbVendor,
                                                      callback: function($$v) {
                                                        _vm.qbVendor = $$v
                                                      },
                                                      expression: "qbVendor"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-avatar",
                                                    { staticClass: "pl-3" },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            fab: "",
                                                            small: "",
                                                            flat: "",
                                                            color: "accent",
                                                            disabled:
                                                              _vm.loadingVendors
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color: "accent"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.refreshQuickbooksVendors(
                                                                    _vm
                                                                      .invoicingCompany
                                                                      .id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("refresh")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("v-divider"),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _vm.createInvoice
                                                    ? _c(
                                                        "v-list-tile-title",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Customer Payment Terms"
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "v-list-tile-title",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "terms.vendor"
                                                              )
                                                            ) + " Payment Terms"
                                                          )
                                                        ]
                                                      )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c("v-select", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  items: _vm.salesTerms,
                                                  loading:
                                                    _vm.loadingSalesTerms,
                                                  disabled:
                                                    _vm.loadingSalesTerms,
                                                  label: _vm.createInvoice
                                                    ? "Payment Terms"
                                                    : "Remitting Terms",
                                                  "item-text": "name",
                                                  "item-value": "id",
                                                  "return-object": "",
                                                  "error-messages": _vm.errors.first(
                                                    "terms",
                                                    "step2"
                                                  ),
                                                  "data-vv-as": "Payment Terms",
                                                  "data-vv-name": "terms",
                                                  "data-vv-scope": "step2"
                                                },
                                                model: {
                                                  value: _vm.qbTerms,
                                                  callback: function($$v) {
                                                    _vm.qbTerms = $$v
                                                  },
                                                  expression: "qbTerms"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-avatar",
                                                { staticClass: "pl-3" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        fab: "",
                                                        small: "",
                                                        flat: "",
                                                        color: "accent",
                                                        disabled:
                                                          _vm.loadingSalesTerms
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "accent"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.refreshQuickbooksPaymentTerms(
                                                                _vm
                                                                  .invoicingCompany
                                                                  .id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          refresh\n                        "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _vm.createInvoice
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                large: "",
                                                block: "",
                                                disabled:
                                                  _vm.isQuickbooksInfoLoading ||
                                                  _vm.errors.any("step2"),
                                                color: _vm.btnColor,
                                                loading: _vm.loading
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.completeInvoiceStep2()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "pr-2",
                                                  attrs: {
                                                    large: "",
                                                    color: "white"
                                                  }
                                                },
                                                [_vm._v("cloud_upload")]
                                              ),
                                              _vm._v(" "),
                                              _vm.isUsingTax
                                                ? _c("v-span", [
                                                    _vm._v(
                                                      "Select Tax Withholding"
                                                    )
                                                  ])
                                                : _c("v-span", [
                                                    _vm._v(
                                                      "Create Direct Invoice"
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.createInvoice
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                block: "",
                                                large: "",
                                                color: _vm.btnColor,
                                                disabled: _vm.errors.any(
                                                  "step2"
                                                )
                                              },
                                              on: {
                                                click:
                                                  _vm.setupExportQuickbooksStep3
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "pr-2",
                                                  attrs: {
                                                    large: "",
                                                    color: "white"
                                                  }
                                                },
                                                [_vm._v("list")]
                                              ),
                                              _vm._v(
                                                "\n                  Add " +
                                                  _vm._s(
                                                    _vm.$t("terms.vendor")
                                                  ) +
                                                  " Discounts\n                "
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            block: "",
                                            flat: "",
                                            color: _vm.btnColor
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.exportQuickbooksStep = 1
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Back\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-stepper-content",
                                    {
                                      attrs: {
                                        step: _vm.exportQuickbooksDiscountsStep
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list",
                                        { attrs: { "two-line": "" } },
                                        [
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _vm.createInvoice
                                                    ? [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              "Apply Deductions"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-sub-title",
                                                          [
                                                            _vm._v(
                                                              "from gross payment in expense accounts"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              "Apply Vendor Discounts"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-sub-title",
                                                          [
                                                            _vm._v(
                                                              "to income accounts"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        fab: "",
                                                        small: "",
                                                        color: "accent"
                                                      },
                                                      on: {
                                                        click: _vm.addDiscount
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "white"
                                                          }
                                                        },
                                                        [_vm._v("add")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.discounts, function(
                                            discount,
                                            index
                                          ) {
                                            return _c(
                                              "v-list-group",
                                              {
                                                key: "discounts_group_" + index,
                                                attrs: { value: discount.open }
                                              },
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    attrs: {
                                                      slot: "activator"
                                                    },
                                                    slot: "activator"
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                discount.description
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-sub-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                discount.account
                                                                  .accountName
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-sub-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.discountSubtitle(
                                                                  discount
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-tile",
                                                  [
                                                    _c(
                                                      "v-list-tile-action",
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              color: "accent",
                                                              fab: "",
                                                              small: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.removeDiscount(
                                                                  discount
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color: "white"
                                                                }
                                                              },
                                                              [_vm._v("cancel")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label:
                                                          "Discount Description"
                                                      },
                                                      model: {
                                                        value:
                                                          discount.description,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            discount,
                                                            "description",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "discount.description"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-tile",
                                                  [
                                                    _c("v-autocomplete", {
                                                      staticClass: "mt-2",
                                                      attrs: {
                                                        solo: "",
                                                        items:
                                                          _vm.quickbooksDiscountAccounts,
                                                        loading:
                                                          _vm.loadingAccounts,
                                                        disabled:
                                                          _vm.loadingAccounts,
                                                        label:
                                                          "Quickbooks Account",
                                                        "item-text":
                                                          "accountName",
                                                        "item-value":
                                                          "accountId",
                                                        "return-object": ""
                                                      },
                                                      model: {
                                                        value: discount.account,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            discount,
                                                            "account",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "discount.account"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-tile",
                                                  [
                                                    !discount.percent
                                                      ? _c("span", [
                                                          _vm._v("$")
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("v-float-field", {
                                                      attrs: {
                                                        label: "Discount Amount"
                                                      },
                                                      model: {
                                                        value: discount.amount,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            discount,
                                                            "amount",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "discount.amount"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    discount.percent
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass: "pr-2"
                                                          },
                                                          [_vm._v("%")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        label: "Percent"
                                                      },
                                                      model: {
                                                        value: discount.percent,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            discount,
                                                            "percent",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "discount.percent"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      !_vm.createInvoice
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                large: "",
                                                block: "",
                                                color: "accent",
                                                disabled:
                                                  _vm.isQuickbooksInfoLoading ||
                                                  _vm.errors.any("step3"),
                                                loading: _vm.loading
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.completeInvoiceStep3()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "pr-2",
                                                  attrs: {
                                                    large: "",
                                                    color: "white"
                                                  }
                                                },
                                                [_vm._v("cloud_upload")]
                                              ),
                                              _vm._v(" "),
                                              _vm.isUsingTax
                                                ? _c("v-span", [
                                                    _vm._v(
                                                      "Select Tax Withholding"
                                                    )
                                                  ])
                                                : _c("v-span", [
                                                    _vm._v(
                                                      "Export " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "terms.billable-expense"
                                                          )
                                                        )
                                                    )
                                                  ])
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            block: "",
                                            flat: "",
                                            color: _vm.btnColor
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.exportQuickbooksStep = 2
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Back\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-stepper-content",
                                    {
                                      attrs: {
                                        step: _vm.exportQuickbooksTaxStep
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list",
                                        { attrs: { "two-line": "" } },
                                        [
                                          _vm.createInvoice
                                            ? _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c(
                                                        "v-list-tile-title",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Sales Tax Code"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _vm._v(
                                                            "invoice sales line item tax"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.createInvoice
                                            ? _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c(
                                                        "v-list-tile-title",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Purchases Tax Code"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _vm._v(
                                                            "bill / purchase line item tax"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            { staticClass: "pt-1" },
                                            [
                                              _c("v-autocomplete", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                staticClass: "mt-2",
                                                attrs: {
                                                  items: _vm.taxCodes,
                                                  loading: _vm.loadingTaxCodes,
                                                  disabled: _vm.loadingTaxCodes,
                                                  label: "Quickbooks Tax Code",
                                                  "item-text": "name",
                                                  "item-value": "id",
                                                  "return-object": "",
                                                  "error-messages": _vm.errors.first(
                                                    "taxCode",
                                                    "step4"
                                                  ),
                                                  "data-vv-as":
                                                    "Quickbooks Tax Code",
                                                  "data-vv-name": "taxCode",
                                                  "data-vv-scope": "step4"
                                                },
                                                model: {
                                                  value: _vm.taxCode,
                                                  callback: function($$v) {
                                                    _vm.taxCode = $$v
                                                  },
                                                  expression: "taxCode"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-avatar",
                                                { staticClass: "pl-3" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        fab: "",
                                                        small: "",
                                                        flat: "",
                                                        color: "accent",
                                                        disabled:
                                                          _vm.loadingTaxCodes
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "accent"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.refreshQuickbooksTaxCodes(
                                                                _vm
                                                                  .invoicingCompany
                                                                  .id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("refresh")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-divider")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            large: "",
                                            block: "",
                                            disabled:
                                              _vm.isQuickbooksInfoLoading ||
                                              _vm.errors.any("step4"),
                                            loading: _vm.loading,
                                            color: _vm.btnColor
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.exportIntoQuickbooks()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "pr-2",
                                              attrs: {
                                                large: "",
                                                color: "white"
                                              }
                                            },
                                            [_vm._v("cloud_upload")]
                                          ),
                                          _vm._v(" "),
                                          _vm.createInvoice
                                            ? _c("span", [
                                                _vm._v("Export Invoice")
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "Export " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "terms.billable-expense"
                                                      )
                                                    )
                                                )
                                              ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            block: "",
                                            flat: "",
                                            color: _vm.btnColor
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.exportQuickbooksStep =
                                                _vm.exportQuickbooksTaxStep - 1
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Back\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-badge",
        { attrs: { right: "", overlap: "", color: "transparent" } },
        [
          _c(
            "template",
            { slot: "badge" },
            [
              _c("v-icon", { attrs: { color: "green darken-1" } }, [
                _vm._v("\n        new_releases\n      ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.showButton
            ? _c("v-quickbooks-btn", {
                attrs: { disabled: _vm.disabled, loading: _vm.loading },
                on: { click: _vm.openQuickbooksModal }
              })
            : _c("v-quickbooks-btn", {
                attrs: { loading: _vm.loading },
                on: { click: _vm.openInfoModal }
              })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-629b72bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-629b72bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qb/QuickbooksBillingButton.vue
// module id = null
// module chunks = 